// Utility function to format currency values consistently
export const formatCurrency = (value) => {
  // Convert to number if it's a string
  const num = typeof value === 'string' ? parseFloat(value) : value;
  
  // Format to 2 decimal places and add $ prefix
  return `$${num.toFixed(2)}`;
};

// Utility function to store currency values in database format
export const storeCurrency = (value) => {
  // Convert to number if it's a string
  const num = typeof value === 'string' ? parseFloat(value) : value;
  
  // Return as a number with exactly 2 decimal places
  return parseFloat(num.toFixed(2));
};